import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LicenseStorage } from '@portal-core/license-storage/models/license-storage.model';

@CollectionStateSelectors({
  stateType: LicenseStorageState
})
@State<LicenseStorageState>({
  name: LicenseStorageState.source
})
@Service({ autoProvided: false })
export class LicenseStorageState extends CollectionStateBase {
  static override source = 'LicenseStorage';
  getSource(): string {
    return LicenseStorageState.source;
  }
}

@Service()
export class LicenseStorageDataService extends CollectionDataServiceBase<LicenseStorage> {
  protected readonly stateType = LicenseStorageState;
}
